import React, { useEffect, useState } from "react";
import Icon from "@gc-npm/components.icon-glyph";
import styles from "./style";
import PropTypes from "prop-types";

const FiltersMobileButton = ({ handleClick, text }) => {
  const [isVisible, setIsVisible] = useState(false);

  const handleScroll = () => {
    if (window && window.scrollY > 100) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <div className="filterCenter">
        <div className={`stickyBarFilter ${isVisible ? "visible" : ""}`}>
          <button type="button" className="badgeFiltrosMobile" onClick={handleClick}>
            {`${text}`}
            <Icon id="filtro-m" height={18} color="white" position="right" />
          </button>
        </div>
      </div>
      <div className="btnUpEnd">
        <div className={`stickyBarFilter ${isVisible ? "visible" : ""}`}>
          <button
            type="button"
            className="scroll-up-button"
            aria-label="Volver arriba"
            onClick={scrollToTop}
          >
            <Icon
              id="cheuron-up-m"
              height={15}
              color="white"
              position="right"
            />
          </button>
        </div>
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

FiltersMobileButton.propTypes = {
  /**
   * funcion que ejecuta el botón
   */
  handleClick: PropTypes.func,
  /**
   * texto que se muestra en el boton
   */
  text: PropTypes.string,
};

FiltersMobileButton.defaultProps = {
  text: "",
};

export default FiltersMobileButton;
